import EntityId from './EntityId';
import EntityDetails from './EntityDetails';
import EntityMemberships from './EntityMemberships';
import { useCallback } from 'react';

const EntityCard = ({
    entityData = {},
    entityType,
    showBox = true,
    showMemberships = true,
    customFieldsToShow = undefined,
    customDetailsClass = '',
    showGoToInvestigation,
    showEntityId = true
}) => {
    const entityDetails = entityData.details ? { ...entityData.details } : {};
    entityDetails.tokensCount = entityData.tokensCount;
    entityDetails.rules = entityData.rules;
    entityDetails.riskLevel = entityData.RiskLevel;

    const getGridTemplateColumns = useCallback(() => {
        if (showMemberships) {
            if (showEntityId) {
                return 'grid-cols-[minmax(min-content,_25%)_minmax(min-content,_45%)_minmax(min-content,_30%)]';
            }
            return 'grid-cols-[minmax(min-content,_70%)_minmax(min-content,_30%)]';
        } else if (showEntityId) {
            return 'grid-cols-[minmax(min-content,_35%)_minmax(min-content,_65%)]';
        }
        return '';
    }, [showEntityId, showMemberships]);

    return (
        <div
            className={`h-full grid ${getGridTemplateColumns()} w-full 
            ${
                showBox
                    ? 'shadow-[0_4px_8px_0_rgb(0_0_0_/_20%),0_6px_20px_0_rgb(0_0_0_/_19%)] px-0 py-[15px] rounded-[10px] bg-[#212a30]'
                    : ''
            }`}>
            {showEntityId && (
                <div className="min-h-0 px-5 py-0">
                    <EntityId
                        entityDetails={entityDetails}
                        entityType={entityType}
                        showGoToInvestigation={showGoToInvestigation}
                    />
                </div>
            )}
            <div
                className={`grid auto-rows-fr grid-cols-1 min-h-0 h-full w-full px-5 py-0 border-x-white/20 overflow-x-clip ${
                    showMemberships ? 'border-r border-solid border-l' : ''
                } ${customDetailsClass}`}>
                <EntityDetails
                    entityDetails={entityDetails}
                    entityType={entityType}
                    customFieldsToShow={customFieldsToShow}
                    entityData={entityData}
                />
            </div>
            {showMemberships && (
                <div className="min-h-0 px-5 py-0">
                    <EntityMemberships entityGroups={entityData.groups} parentGuidData={entityData.parentGuidData} />
                </div>
            )}
        </div>
    );
};

export default EntityCard;
